import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/services/auth-service';
import { DatabaseConnection } from './database-connection';
import { HttpClient } from '@angular/common/http';
import { PrintData } from '../model';
import { PrintComponent } from '../components/print-component/print-component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from './toastr-service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintService {

  printLoading : BehaviorSubject<boolean> = new BehaviorSubject(false)
  constructor(
    private authUser : AuthService,
    private  dbConnection : DatabaseConnection,
    private http : HttpClient,
    private dialog : MatDialog,
    private toastr : ToastrService
  ){}

    imprimer(assurance : string, detail : boolean = false){
      
      if(detail){
        window.open(this.dbConnection.remoteConnection.value  + 'contrat-assurance?site='+this.authUser.getCurrentUser().user.site?.id+'&assurance='+assurance+'&session_id='+this.authUser.getCurrentUser().token.token_id, '_blank')
        return;
      }
      this.printLoading.next(true)

      this.http.post(this.dbConnection.remoteApiConnection.value  + 'contrat-assurance',
        {assurance : assurance}, { responseType: 'blob' })
        .subscribe({
          next : (blob : Blob) =>{
            const data : PrintData ={
              assurance : assurance,
              name : "Contrat",
              dataBlob : blob,
              detail : 'contrat-assurance'
            }
            console.log(data);
            
            const dialogRef = this.dialog.open(PrintComponent, {
              width : '1200px',
              enterAnimationDuration : '500ms',
              exitAnimationDuration : '500ms',
              disableClose : true,
              data : data
            });
            this.printLoading.next(false)

          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
            this.printLoading.next(false)
          }
        })
    }

    imprimerRecu(assurance : string, detail : boolean = false){

      if(detail){
        window.open(this.dbConnection.remoteConnection.value  + 'recu-assurance?site='+this.authUser.getCurrentUser().user.site?.id+'&assurance='+assurance+'&session_id='+this.authUser.getCurrentUser().token.token_id, '_blank')
        return
      }

      this.printLoading.next(true)
      this.http.post(this.dbConnection.remoteApiConnection.value  + 'recu-assurance',
        {assurance : assurance},  { responseType: 'blob' })
        .subscribe({
          next : (blob : Blob) =>{
            const data : PrintData ={
              assurance : assurance,
              name : "Recu",
              dataBlob : blob,
              detail : "recu-assurance"
            }
            const dialogRef = this.dialog.open(PrintComponent, {
              width : '1200px',
              enterAnimationDuration : '500ms',
              exitAnimationDuration : '500ms',
              disableClose : true,
              data : data
            });
            this.printLoading.next(false)
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
            this.printLoading.next(false)
          }
        })
    }

    imprimerAttestation(assurance : string, detail : boolean = false){

      if(detail){
        window.open(this.dbConnection.remoteConnection.value  + 'attestation-assurance?site='+this.authUser.getCurrentUser().user.site?.id+'&assurance='+assurance+'&session_id='+this.authUser.getCurrentUser().token.token_id, '_blank')
        return;
      }

      this.printLoading.next(true)

      this.http.post(this.dbConnection.remoteApiConnection.value  + 'attestation-assurance',
        {assurance : assurance},  { responseType: 'blob' })
        .subscribe({
          next : (blob : Blob) =>{
            const data : PrintData ={
              assurance : assurance,
              name : "Attestation",
              dataBlob : blob,
              detail : 'attestation-assurance'
            }
            const dialogRef = this.dialog.open(PrintComponent, {
              width : '1200px',
              enterAnimationDuration : '500ms',
              exitAnimationDuration : '500ms',
              disableClose : true,
              data : data
            });
            this.printLoading.next(false)
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
            this.printLoading.next(false)
          }
        })
      
    }

    imprimerCarteRose(assurance : string, detail : boolean = false){

      if(detail){
        window.open(this.dbConnection.remoteConnection.value  + 'carte-rose-assurance?site='+this.authUser.getCurrentUser().user.site?.id+'&assurance='+assurance+'&session_id='+this.authUser.getCurrentUser().token.token_id, '_blank')
        return;
      }

      this.printLoading.next(true)
      this.http.post(this.dbConnection.remoteApiConnection.value  + 'carte-rose-assurance',
        {assurance : assurance},  { responseType: 'blob' })
        .subscribe({
          next : (blob : Blob) =>{
            const data : PrintData ={
              assurance : assurance,
              name : "Carte rose",
              dataBlob : blob,
              detail : 'carte-rose-assurance'
            }
            const dialogRef = this.dialog.open(PrintComponent, {
              width : '1200px',
              enterAnimationDuration : '500ms',
              exitAnimationDuration : '500ms',
              disableClose : true,
              data : data
            });
            this.printLoading.next(false)
          },
          error : (err) =>{
            this.toastr.error("Une erreur est survenue")
            this.printLoading.next(false)
          }
      })
      
    }
}
